import { render, staticRenderFns } from "./Courier91.vue?vue&type=template&id=28638eb9&scoped=true&"
import script from "./Courier91.vue?vue&type=script&lang=js&"
export * from "./Courier91.vue?vue&type=script&lang=js&"
import style0 from "./Courier91.vue?vue&type=style&index=0&id=28638eb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28638eb9",
  null
  
)

export default component.exports